/* global NGXD, NGX */

// Core lib dependencies.
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

// Component dependencies.
import Components from './components.js';
import Reducer from './reducer.js';

// Config.
import Config from './config/config.js';

/**
 * <pre>
 * Privacy Management UI.
 *
 * This app is responsible for rendering and handling all functionality relating to privacy management: cookie consent
 * gathering, privacy settings button, and the cookies disabled modal.  It uses the Privacy Service to manage privacy consent state.
 *
 * Summary of responsibilities:
 *
 *  - registers itself and any dependencies with NGXD
 *  - dispatches Redux action to register initial state
 *  - renders React component to page
 * </pre>
 *
 * @memberof module:PrivacyManagement
 * @namespace
 */
const App = {
  init: function () {
    // Register ourselves with NGXD.
    // JSDoc FYI - all scoped methods of this closure have explicit @memberof tags, because JSDoc is not good at understanding closures!
    NGXD.registerApp(
      Config.publicName,
      Config.stateKey,
      Reducer.rootReducer,
      (function () {
        'use strict';

        // Redux _store.
        let _store;

        /**
         * Init.
         *
         * @memberof module:PrivacyManagement.App
         *
         * @param store				{object} The Redux store.
         */
        const init = (store) => {

          // Store injected params.
          _store = store;

          ReactDOM.render(
            <Provider store={_store}>
              <Components.PrivacyManagement />
            </Provider>,
            document.getElementById('xPrivacyManagement')
          );
        };

        /**
         * Convenience method for calling _store dispatch method. Checks _store exists first.
         *
         * @memberof module:PrivacyManagement.App
         *
         * @param action {object} The Redux action.
         */
        const dispatch = (action) => {
          if (_store) {
            _store.dispatch(action);
          }
        };

        // Expose scoped properties.
        return {
          init: init,
        };
      })(),
      // Array of additional reducer dependencies.
      []
    );
  },
};

export default App;
